const ROUTER_MAP = {
  首页: 'index',
  中心简介: 'introductionCenter',
  信息服务: 'informationService',
  资源导航: 'resourceNavigation'
}

module.exports = {
  ROUTER_MAP
}
